module.exports = __webpack_public_path__ + "img/baggage.cad1be8a.png";